import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import AuthGuard from './components/auth/AuthGuard';
import LoginForm from './components/auth/LoginForm';
import OAuthCallback from './components/auth/OAuthCallback';
import ResetPasswordPage from './components/auth/ResetPasswordPage';
import Dashboard from './components/dashboard/Dashboard';
import EditorPage from './components/editor/EditorPage';
import ViewerPage from './components/viewer/ViewerPage';
import ReviewBoard from './components/review/ReviewBoard';
import OfflineIndicator from './components/shared/OfflineIndicator';
import { TooltipProvider } from './components/ui/tooltip';

export default function App() {
  return (
    <TooltipProvider delayDuration={400}>
    <BrowserRouter>
      <OfflineIndicator />
      <Routes>
        <Route path="/login" element={<LoginForm />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/auth/callback" element={<OAuthCallback />} />
        <Route
          path="/dashboard"
          element={
            <AuthGuard>
              <Dashboard />
            </AuthGuard>
          }
        />
        <Route
          path="/scene/:id/edit"
          element={
            <AuthGuard>
              <EditorPage />
            </AuthGuard>
          }
        />
        <Route
          path="/scene/:id/view"
          element={
            <AuthGuard>
              <ViewerPage />
            </AuthGuard>
          }
        />
        <Route
          path="/review"
          element={
            <AuthGuard>
              <ReviewBoard />
            </AuthGuard>
          }
        />
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
    </TooltipProvider>
  );
}
